import React from 'react'

import withGame from '../../data/withGame'
import withGamePlayers from '../../data/withGamePlayers'

import WaitingPrompt from './1_WaitingPrompt'
import ActivePrompt from './2_ActivePrompt'
import OverPrompt from './3_OverPrompt'

import RosterContainer from './components/RosterContainer'

import WaitingAction from './1_WaitingAction'
import ActiveAction from './2_ActiveAction'
import OverAction from './3_OverAction'

import {
  Page,
  H2,
} from '../styles'

const Game = (props) => {
  return <Page>
    <H2>{props.game.name}</H2>
    {!props.game.started ? <WaitingPrompt {...props} /> : null }
    {props.game.started && !props.game.winner ? <ActivePrompt {...props} /> : null }
    {props.game.winner ? <OverPrompt {...props} /> : null }

    <RosterContainer players={props.players} />

    {!props.game.started ? <WaitingAction {...props} /> : null }
    {props.game.started && !props.game.winner ? <ActiveAction {...props} /> : null }
    {props.game.winner ? <OverAction {...props} /> : null }
  </Page>
}

export default withGame(withGamePlayers(Game))



// WEBPACK FOOTER //
// ./src/views/game/Game.jsx